import modal from './modal.html';
import view  from './view.html';

/* @ngInject */
export default function () {
	return {
		template:                   view,
		replace:                    true,
		scope:                      true,
		controller: /* @ngInject */ ($scope, STATUSES, $http, DataTablesService, ReportsService, moment, Reports, StaffReportsServiceUsersService, toastr, $uibModal) => {
			$scope.moment = moment;

			$scope.status = STATUSES.UNLOADED;

			$scope.dataTable = DataTablesService.configure({
				id:                 $scope.reportId,
				title:              'Finished Service Users Report',
				frozenColumns:      true,
				reorderableColumns: true,
			}, {
				frozenLeftColumns:  3,
				frozenRightColumns: 2,
				order:              [
					[
						2,
						'asc',
					],
					[
						1,
						'asc',
					],
				],
			});

			$scope.data  = [];
			$scope.error = null;

			$scope.refresh = () => {
				$scope.status = STATUSES.LOADING;

				$scope.data  = [];
				$scope.error = null;

				return Reports.one($scope.reportId)
				              .one('execute')
				              .get()
				              .then((data) => {
					              $scope.data  = data;
					              $scope.error = null;

					              $scope.status = STATUSES.LOADED;

					              return data;
				              })
				              .catch((error) => {
					              $scope.data  = [];
					              $scope.error = error;

					              $scope.status = STATUSES.ERRORED;
				              });
			};

			$scope.openModal = (serviceUserId) => {
				$uibModal.open({
					animation:                  true,
					template:                   modal,
					scope:                      $scope,
					size:                       'lg',
					controller: /* @ngInject */ ($scope, $uibModalInstance) => {
						$scope.modalServiceUser = $scope.data.find((item) => {
							return item['Client Id'] === serviceUserId;
						});

						$scope.modalLeavingTypeOptions = [
							'Service User choice to change providers',
							'Service User Deceased',
							'AAC do not have capacity to provide services',
							'Service User no longer requiring care / Program concluded',
							'Other',
						];

						$scope.modalData = {
							leavingType: $scope.modalServiceUser['Leaving Type'],
						};

						$scope.modalCancel = () => {
							$uibModalInstance.close();
						};

						$scope.modalConfirm = () => {
							StaffReportsServiceUsersService.updateOneServiceUser(serviceUserId, $scope.modalData)
							                               .then((response) => {
								                               toastr.clear();
								                               toastr.success('The service user was successfully updated. To show the latest data, please click the Update button.', 'Success');

								                               $uibModalInstance.close();
							                               })
							                               .catch((error) => {
								                               toastr.clear();
								                               toastr.error('There was an error while updating the service user, please try again.', 'Error');
							                               });
						};
					},
				});
			};

			$scope.refresh();
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/report/reports/68E41CA0-2199-41CA-BCD6-472246DBBFFD/index.js